import { customAxios as axios, getToken } from '../../../request';
import { apiUrl } from '../../../settings';


export const updateGeneralDetailsApi = async (id, data) => {
    const url = `${apiUrl}/generalSubscription/${id}`;
    try {
        let { data: response } = await axios.put(url, data, getToken());
        return { error: false, result: response };
    } catch (error) {
        return { error: true, message: error };
    }
};

export const updatePaymentApi = async (data) => {
    const url = `${apiUrl}/edit-payment`;
    try {
        let { data: response } = await axios.post(url, data, getToken());
        return { error: false, result: response };
    } catch (error) {
        return { error: true, message: error };
    }
};

export const updateCourierApi = async (data) => {
    const url = `${apiUrl}/edit-courier`;
    try {
        let { data: response } = await axios.post(url, data, getToken());
        return { error: false, result: response };
    } catch (error) {
        return { error: true, message: error };
    }
};

export const addJournalToSubscriptionApi = async (id, data) => {
    const url = `${apiUrl}/generalSubscription/add-journal/${id}`;
    try {
        let { data: response } = await axios.post(url, data, getToken());
        return { error: false, result: response };
    } catch (error) {
        return { error: true, message: error };
    }
};

